module.exports = __webpack_public_path__ + "static/media/plate4Img1.964045fc.png";